// @flow
import hasClass from './hasClass';

export default function addClass(element: HTMLElement, cls: string) {
   if (hasClass(element, cls)) {
      return;
   }
   element.className += ' ' + cls;
}
